var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5046_77021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5987 7.91444C12.941 7.18717 13.6682 7.29412 14.5666 7.59358C15.2083 7.80749 16.342 7.5508 16.5987 6.78075L14.9303 4C14.9944 5.00535 14.5666 5.34759 13.9463 5.41176C13.4115 5.41176 13.0693 5.5615 12.834 5.83957L9.83936 10.9519C11.4864 11.0374 13.0907 11.6364 14.4597 13.6043C15.2297 14.6952 16.5773 15.6364 19.1014 16.107C17.7324 16.4064 16.6629 16.0642 15.3367 15.5936",
    fill: "#009FB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3155 15.5936C14.8235 15.4225 14.2888 15.23 13.6898 15.0375C11.9572 14.5027 9.26203 14.2888 7.42246 15.123L4 21.0054C6.33155 19.0588 10.5455 18.5669 13.5401 19.7006C17.0053 21.0054 20.3209 21.3904 24 19.508L21.4973 15.2727C21.0695 15.615 20.6203 15.8075 20.1925 15.8717L20.6631 12.4706C19.123 12.6417 17.8182 12.2567 16.8342 11.1444C15.3797 9.45456 13.9679 8.19253 12.5989 7.89307",
    fill: "#009FB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3958 11.2085C11.2941 11.2085 12.0214 11.9358 12.0428 12.8342C12.0428 13.7326 11.3155 14.4598 10.4171 14.4598C9.51875 14.4598 8.79148 13.7326 8.79148 12.8556C8.77009 11.9572 9.49736 11.2299 10.3958 11.2085Z",
    fill: "#E77F32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5046_77021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.0053,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.d9cac828f4695c244693c8897ec19676.svg";
export { ForwardRef as ReactComponent };